export function MathOperations(exp = "") {
    let r = null;

    try {
        console.log("EVAL!");
        r = exp;
    } catch (ex) {
        console.error(ex);
    }

    return r;

    /* === FUNÇÕES DA MÁQUINA DE CÁLCULO === */

    function abs(x) {
        return Math.abs(x);
    }

    function _reduce(args, func) {
        return Object.keys(args).reduce(func, 0);
    }

    function compare(x, y) {
        if (x == y) return 0;
        if (x < y) return -1;
        if (x > y) return 1;
    }

    function divide() {
        return _reduce(arguments, (r, i) => {
            r = r ? r / arguments[i] : arguments[i];
            return r;
        });
    }

    function mean() {
        return sum(...arguments) / arguments.length;
    }

    function multiply() {
        return _reduce(arguments, (r, i) => {
            r = r ? r * arguments[i] : arguments[i];
            return r;
        });
    }

    function negative(x, force = false) {
        x = force ? Math.abs(x) : x;
        return -x;
    }

    function subtract() {
        return _reduce(arguments, (r, i) => {
            r = r ? r - arguments[i] : arguments[i];
            return r;
        });
    }

    function sum() {
        return _reduce(arguments, (r, i) => {
            r = r ? r + arguments[i] : arguments[i];
            return r;
        });
    }

    function percentage(x, y = 100, convert = false) {
        const times = convert ? 100 : 1;
        return (x / y) * times;
    }
}
